import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const Text = ({ children, size = "body", as = "p", className = "" }) => {
  const Tag = as;

  const sizeClasses = {
    header: "text-4xl font-bold",
    subheader: "text-2xl font-semibold",
    body: "text-base font-normal text-grey-600",
  };

  return <Tag className={clsx(sizeClasses[size], className)}>{children}</Tag>;
};

Text.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(["header", "subheader", "body"]),
  as: PropTypes.string, // Allows you to render as h1, h2, span, etc.
  className: PropTypes.string,
};

export default Text;
